import React, { useEffect, useState } from 'react';
import { Box, Switch, FormControlLabel, Typography } from '@mui/material';
import ItemConfigurationPanel from './ItemConfigurationPanel';
import ItemConfigurationPanelExcel from './ItemConfigurationPanelExcel';
import { Product } from '../../order';

interface ItemConfigurationPanelWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  product: Product | null;
  onComplete: (product: Product) => void;
  isEditMode?: boolean;
  onUpdate?: (product: Product) => void;
  isIncrementalMode?: boolean;
  onIncrementalComplete?: (product: Product) => void;
  // New props for auto order creation
  customerId?: string;
  siteId?: string;
  orderId?: string; // Add orderId for editing existing orders
  orderData?: {
    amount?: string;
    paymentStatus?: string;
    priority?: string;
    dueDate?: string;
    notes?: string;
  };
  onOrderCreated?: (order: any) => void;
  onOrderUpdated?: (order: any) => void; // New callback for when order is updated
  onProductAdded?: (product: any) => void; // New callback for when product is added to existing order
  isReadOnly?: boolean; // New prop: when true, all fields and buttons are disabled/readonly
}

const ItemConfigurationPanelWrapper: React.FC<ItemConfigurationPanelWrapperProps> = (props) => {

  const [useExcelView, setUseExcelView] = useState(false);

  const handleViewToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUseExcelView(event.target.checked);
  };

  return (
    <>
      {/* View Toggle - Only show when panel is open */}
      {/* {props.isOpen && (
        <div className="fixed top-4 right-[45%] z-[60] bg-white rounded-lg shadow-lg p-2 border">
          <FormControlLabel
            control={
              <Switch
                checked={useExcelView}
                onChange={handleViewToggle}
                color="primary"
                size="small"
              />
            }
            label={
              <Typography variant="body2" sx={{ fontSize: '12px' }}>
                {useExcelView ? 'Excel View' : 'Card View'}
              </Typography>
            }
          />
        </div>
      )} */}

      {/* Render appropriate component based on toggle */}
      {useExcelView ? (
        <ItemConfigurationPanelExcel {...props} />
      ) : (
        <>
          {console.log('🔄 ItemConfigurationPanelWrapper - Product being passed to ItemConfigurationPanel:', {
            id: props.product?.id,
            name: props.product?.name,
            type: props.product?.type,
            label: props.product?.label,
            location: props.product?.location
          })}
          <ItemConfigurationPanel 
            {...props}
            customerId={props.customerId}
            siteId={props.siteId}
            orderId={props.orderId}
            orderData={props.orderData}
            onOrderCreated={props.onOrderCreated}
            onOrderUpdated={props.onOrderUpdated}
            onProductAdded={props.onProductAdded}
            isReadOnly={props.isReadOnly}
          />
        </>
      )}
    </>
  );
};

export default ItemConfigurationPanelWrapper;
